/**
 * @description 全局变量配置
 */
module.exports = {
  //显示sidebar
  showSideBar: true,
  orgTitle: "中国工程物理研究院",
  //开启系统循环播报
  showAd: false,
  // 开发以及部署时的URL
  publicPath: "",
  // 生产环境构建文件的目录名
  outputDir: "dist",
  // 放置生成的静态资源 (js、css、img、fonts) 的 (相对于 outputDir 的) 目录。
  assetsDir: "static",
  // 开发环境每次保存时是否输出为eslint编译警告
  lintOnSave: true,
  // 进行编译的依赖
  transpileDependencies: ["vue-echarts", "resize-detector"],
  // 默认的接口地址 如果是开发环境和生产环境走vab-mock-server，当然你也可以选择自己配置成需要的接口地址
  baseURL:
    process.env.NODE_ENV === "development" || process.env.NODE_ENV === "preview"
      ? "vab-mock-server"
      : "vab-mock-server",
  remoteURL:
    process.env.NODE_ENV === "development" || process.env.NODE_ENV === "preview"
      ? "http://172.20.11.18:8080"
      : "http://172.20.11.18:8080",
  //域名地址，简历分享前面域名使用
  developer:
    process.env.NODE_ENV === "development" || process.env.NODE_ENV === "preview"
      ? "https://zpxx.caep.cn"
      : "https://zpxx.caep.cn",
  //标题 （包括初次加载雪花屏的标题 页面的标题 浏览器的标题）
  title: "人才招聘网",
  //简写
  abbreviation: "vab",
  //开发环境端口号
  devPort: "8081",
  //版本号
  version: process.env.VUE_APP_VERSION,
  copyright: "中物院人事教育部 since 2018. All Rights Reserved.",
  //是否显示页面底部版权信息，建议您显示，当然您也可以选择不显示，不管您是付费用户还是未付费用户您都有选择显示或者不显示的权利
  footerCopyright: process.env.NODE_ENV !== "development" ? true : true,
  //是否显示右上角github图标
  githubCorner: process.env.NODE_ENV !== "development" ? true : false,
  //是否显示顶部进度条
  progressBar: true,
  //缓存路由的最大数量
  keepAliveMaxNum: 99,
  // 路由模式，可选值为 history 或 hash
  routerMode: "hash",
  //不经过token校验的路由
  routesWhiteList: [
    "/index",
    "/login",
    "/adminLogin",
    "/forgetPass",
    "/register",
    "/404",
    "/401",
  ],
  //加载时显示文字
  loadingText: "正在加载中...",
  //token名称
  tokenName: "token",
  //token在localStorage、sessionStorage、cookie存储的key的名称
  tokenTableName: "vue-admin-framework",
  //token存储位置localStorage sessionStorage cookie
  storage: "localStorage",
  //token失效回退到登录页时是否记录本次的路由
  recordRoute: true,
  //是否显示logo，不显示时设置false，显示时请填写remixIcon图标名称，暂时只支持设置remixIcon
  logo: "vuejs-fill",
  //是否国定头部 固定fixed 不固定noFixed
  header: "fixed",
  //横纵布局 horizontal vertical
  layout: "horizontal",
  //是否开启主题配置按钮
  themeBar: false,
  //是否显示多标签页
  tagsBar: false,
  //是否显示骨架屏
  skeleton: false,
  //配后端数据的接收方式application/json;charset=UTF-8或者application/x-www-form-urlencoded;charset=UTF-8
  // contentType: "application/json;charset=UTF-8",
  contentType: "application/x-www-form-urlencoded;charset=UTF-8",
  //消息框消失时间
  messageDuration: 1500,
  //最长请求时间
  requestTimeout: 5000,
  //操作正常code，支持String、Array两种方式
  successCode: [200, 204, 0, 1100],
  //登录失效code
  invalidCode: 402,
  //无权限code
  noPermissionCode: 401,
  //强制重新登录
  forceReLoginCode: [1001, 1002, 1003, 1004],
  //是否显示在页面高亮错误
  errorLog: ["development", "test", "production"],
  //是否开启登录拦截
  loginInterception: false,
  //是否依据mock数据生成webstorm HTTP Request请求文件
  httpRequestFile: false,
  //intelligence和all两种方式，前者后端权限只控制permissions不控制view文件的import（前后端配合，减轻后端工作量），all方式完全交给后端前端只负责加载
  authentication: "intelligence",
  //vertical布局时是否只保持一个子菜单的展开
  uniqueOpened: true,
  //vertical布局时默认展开的菜单path，使用逗号隔开建议只展开一个
  defaultOopeneds: ["/vab"],
  //需要加loading层的请求，防止重复提交
  debounce: ["doEdit"],
  //需要自动注入并加载的模块
  providePlugin: { maptalks: "maptalks", "window.maptalks": "maptalks" },
  //npm run build时是否自动生成7z压缩包
  build7z: false,
  //代码生成机生成在view下的文件夹名称
  templateFolder: "project",
  // 默认分页信息
  defaultPageSizes: [10, 20, 50, 100],
};
